// Shared eligibility rules — mirror backend core/booking_rules.py so the picker and the
// server never disagree. Referees are no longer hidden: callers show the reason instead.

export const REFEREE_AGE_ORDER = [
  "U6", "U7", "U8", "U9", "U10", "U11", "U12",
  "U13", "U14", "U15", "U16", "U17", "U18", "Adults",
];

export function refCanOfficiateAge(ref, teamAge) {
  if (!ref?.max_age_group || !teamAge) return true;
  const maxIdx = REFEREE_AGE_ORDER.indexOf(ref.max_age_group);
  const teamIdx = REFEREE_AGE_ORDER.indexOf(teamAge);
  if (maxIdx === -1 || teamIdx === -1) return true;
  return teamIdx <= maxIdx;
}

// League eligibility follows the league's match day vs the referee's Sat/Sun flags.
export function refCanOfficiateLeague(ref, league) {
  const md = league?.match_day || "both";
  const sat = ref?.available_saturday !== false;
  const sun = ref?.available_sunday !== false;
  if (md === "saturday") return sat;
  if (md === "sunday") return sun;
  return sat || sun;
}

export function refAvailableOnDate(ref, ymd) {
  if (!ymd || !ref) return true;
  const dow = new Date(`${ymd}T12:00:00`).getDay(); // 0=Sun, 6=Sat
  if (dow === 6) return ref.available_saturday !== false;
  if (dow === 0) return ref.available_sunday !== false;
  return true;
}

// Short reason a referee can't take this game, or null when eligible.
export function refIneligibleReason(ref, { teamAge, league, ymd }) {
  if (!refCanOfficiateAge(ref, teamAge)) return `up to ${ref.max_age_group} only`;
  if (!refCanOfficiateLeague(ref, league)) {
    const days = ref.available_sunday === false ? "Saturdays" : ref.available_saturday === false ? "Sundays" : "no weekends";
    return `${league?.match_day === "sunday" ? "Sunday" : "Saturday"} league — ref does ${days} only`;
  }
  if (!refAvailableOnDate(ref, ymd)) {
    const dow = new Date(`${ymd}T12:00:00`).getDay();
    return `not available ${dow === 6 ? "Saturdays" : "Sundays"}`;
  }
  return null;
}

// Pitch game_format must match the team's game_format when both are set.
export function pitchFormatOkForTeam(pitch, team) {
  const pf = pitch?.game_format;
  const tf = team?.game_format;
  if (!pf || !tf) return true;
  return pf === tf;
}
